import { handleActions } from "redux-actions";

import { getContactsListAsyncAction, resetAction } from "./contactsActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	list: defaultAjaxState,
	post_contact: defaultAjaxState,
	update_contact: defaultAjaxState,
};

export const contactsReducer = handleActions(
	new Map([
		// get contact list
		[
			getContactsListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					loading: true,
				},
			}),
		],
		[
			getContactsListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					response: payload,
				},
			}),
		],
		[
			getContactsListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
